// extracted by mini-css-extract-plugin
export var pillWrapper = "_ok-0";
export var showOverflow = "_ok-1";